/**
 * AlgorithmicTradingPage — AT Console
 *
 * Rutas:
 *   /algorithmic-trading                    → ATHub (selector de consolas)
 *   /algorithmic-trading/hesh               → HeSH Console    [pendiente]
 *   /algorithmic-trading/pricing-committee  → Pricing Committee [pendiente]
 *
 * Las consolas individuales se incorporan cuando están formalmente definidas
 * con el equipo. Por ahora, cualquier sub-ruta redirige al Hub.
 */

import { useMatch, Navigate } from 'react-router-dom';
import { ATHub } from './modules/ATHub/ATHub';

export const AlgorithmicTradingPage = () => {
  const matchHesh = useMatch('/algorithmic-trading/hesh');
  const matchPC   = useMatch('/algorithmic-trading/pricing-committee');

  if (matchHesh || matchPC) {
    return <Navigate to="/algorithmic-trading" replace />;
  }

  return <ATHub />;
};
